
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_1yz9c_p4ph0_93",
  "series--bar": "awsui_series--bar_1yz9c_p4ph0_94",
  "series__rect": "awsui_series__rect_1yz9c_p4ph0_94",
  "exiting": "awsui_exiting_1yz9c_p4ph0_111",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_1yz9c_p4ph0_1",
  "root": "awsui_root_1yz9c_p4ph0_137",
  "series--highlighted": "awsui_series--highlighted_1yz9c_p4ph0_150",
  "series__bar--highlighted": "awsui_series__bar--highlighted_1yz9c_p4ph0_151",
  "series--dimmed": "awsui_series--dimmed_1yz9c_p4ph0_155",
  "series--threshold": "awsui_series--threshold_1yz9c_p4ph0_159",
  "bar-group": "awsui_bar-group_1yz9c_p4ph0_164"
};
  